import getField from '@form/formGenerator'

export const freeCodeSaveUrl = `${import.meta.env.VITE_API_URL}/api/free-codes`

export const freeCodeFormObject = {
  id: null,
  name: null,
  portionValue: null,
  startsAt: null,
  endsAt: null,
  isActive: false
}

export const freeCodeFormFields = (freeCodeFormObject, updateFormObject, updateFormObjectProp, saveForm, errors, isLoading, t) => {
  const fields = [
    {
      type: 'text',
      name: 'name',
      label: t('labels.name'),
      value: freeCodeFormObject.name,
      key: 'freeCodeFormObject-name',
      cssClass: 'column is-12'
    },
    {
      type: 'text',
      name: 'portionValue',
      label: t('labels.portion'),
      value: freeCodeFormObject.portionValue,
      key: 'freeCodeFormObject-portion',
      cssClass: 'column is-12'
    }, {
      type: 'text',
      name: 'code',
      label: t('labels.code'),
      value: freeCodeFormObject.code,
      key: 'freeCodeFormObject-code',
      cssClass: 'column is-12'
    },
    {
      type: 'date',
      name: 'startsAt',
      value: freeCodeFormObject.startsAt,
      label: t('labels.from'),
      key: 'freeCodeFormObject-startsAt',
      cssClass: 'mission-starts-at column',
      isInline: true,
      isRequired: true
    },
    {
      type: 'date',
      name: 'endsAt',
      value: freeCodeFormObject.endsAt,
      label: t('labels.to'),
      key: 'freeCodeFormObject-endsAt',
      cssClass: 'mission-ends-at column',
      isInline: true,
      isRequired: true
    },
    {
      type: 'switcher',
      name: 'isActive',
      label: t('labels.is_active'),
      value: freeCodeFormObject.isActive,
      cssClass: 'column is-12',
      key: 'freeCodeFormObject-isActive',
      id: 'freeCodeFormObject-isActive',
    },
    {
      type: 'button',
      buttons: true,
      callback: saveForm,
      cancel: false,
      validateText: t('actions.save'),
      cssClassParent: 'column is-12',
      cssClassValidate: 'button is-blue',
      validateIcon: 'icon-done',
      key: 'freeCodeFormObject-form',
      isLoading
    },
    {
      type: 'hidden',
      name: 'id',
      value: parseInt(freeCodeFormObject.id),
      key: 'freeCodeFormObject-id'
    }
  ]
  return fields.map(function (field) {
    return getField({ ...field, error: errors[field.name] ? errors[field.name].errors : '' }, updateFormObject, updateFormObjectProp)
  })
}